export function unitPrice(product, sizeId, qty, inscriptionType, finishId) {
  const p = product || {};
  // Décision du propriétaire (2026-10-09) : la personnalisation (gravure,
  // impression couleur) n'a PLUS de prix affiché — « à déterminer », confirmé
  // dans la soumission. Le prix affiché = produit seul (grandeur, fini, paliers).
  const fee = 0;
  const sizes = Array.isArray(p.sizes) ? p.sizes : [];
  const size = sizes.find((s) => s.id === sizeId) || sizes[0] || { extra: 0 };
  // Prix de vente PAR GRANDEUR si saisi (demande du propriétaire, 2026-10-16) —
  // sinon l'ancien supplément « extra » ajouté au prix de base
  const sizeDelta = size.price != null
    ? Math.round((size.price - (p.base_price || 0)) * 100) / 100
    : (size.extra || 0);
  const finishes = Array.isArray(p.finishes) ? p.finishes : [];
  const finish = finishes.find((f) => f.id === finishId) || finishes[0];
  const finishExtra = finish ? finish.extra || 0 : 0;
  // Anciens paliers : seulement si la case « visibilité au client » est cochée
  // sur la fiche (demande du propriétaire, 2026-10-22) — catalogue 5.0 (produits
  // en vrac) : les paliers SONT le prix de vente, toujours actifs
  const tiersOk = p.show_tiers_client || String(p.catalogue_no || "") === "5.0";
  if (tiersOk && p.price_tiers?.length) {
    const tier = currentPriceTier(p, qty);
    return Math.round((tier.price + sizeDelta + finishExtra + fee) * 100) / 100;
  }
  // Instantané minimal (ex. panier partagé ancien format) : prix unitaire figé
  if (p.base_price == null && typeof p.unit === "number") return p.unit;
  let discount = 0;
  if (tiersOk) {
    [...(p.tiers || [])]
      .sort((a, b) => a.min_qty - b.min_qty)
      .forEach((t) => {
        if (qty >= t.min_qty) discount = t.discount;
      });
  }
  // Rabais UNIQUE (produit → catégorie → grande catégorie → catalogue), résolu
  // côté serveur et servi dans la fiche — « X % dès Y unités » ou « X % » (seuil 0)
  const regle = p.discount_rule;
  if (!discount && regle && regle.pct && qty >= Math.max(1, regle.min_qty || 0)) {
    discount = regle.pct / 100;
  }
  return Math.round((((p.base_price || 0) + sizeDelta + finishExtra) * (1 - discount) + fee) * 100) / 100;
}

export function currentPriceTier(product, qty) {
  const sorted = [...(product.price_tiers || [])].sort((a, b) => a.min_qty - b.min_qty);
  if (!sorted.length) return null;
  let tier = sorted[0];
  sorted.forEach((t) => {
    if (qty >= t.min_qty) tier = t;
  });
  return tier;
}

// Prix unitaire d'un article de panier : le prix ajusté par l'admin dans l'onglet
// Paniers (custom_price) a priorité sur le prix calculé (grille / rabais).
export function itemUnitPrice(item) {
  if (item && typeof item.custom_price === "number") return item.custom_price;
  return unitPrice(item?.pricing, item?.size_id, item?.qty, item?.inscription_type, item?.finish_id);
}

export const TAX_RATES = {
  QC: { gst: 0.05, qst: 0.09975 },
  ON: { hst: 0.13 },
  NB: { hst: 0.15 }, NL: { hst: 0.15 }, PE: { hst: 0.15 },
  NS: { hst: 0.14 },
};

// Rabais d'un code promo sur le panier (même logique que le serveur) :
// portée « inscription » = frais d'inscription seulement, « products » =
// produits sans inscriptions, « order » = sous-total complet (avant livraison/taxes).
export function promoDiscount(items, promo) {
  if (!promo) return 0;
  let total = 0;
  // Personnalisation non tarifée à l'affichage (décision 2026-10-09) : aucune
  // portion « inscription » à isoler — les rabais portent sur le prix produit.
  const insc = 0;
  for (const i of items) {
    total += unitPrice(i.pricing, i.size_id, i.qty, i.inscription_type, i.finish_id) * i.qty;
  }
  // Règle maison : les promos s'appliquent sur les produits seulement — jamais sur
  // la gravure, l'impression ou la personnalisation (doit correspondre à _build_order) ;
  // SAUF portée « tout » (codes témoignage −5 %, 2026-10-07) : total avant taxes.
  const base = promo.scope === "inscription" ? insc
    : promo.scope === "tout" ? total
    : total - insc;
  const d = promo.kind === "pct" ? base * (promo.value / 100) : Math.min(promo.value, base);
  return Math.round(Math.max(0, d) * 100) / 100;
}

export function currentTier(product, qty) {
  let tier = null;
  [...(product.tiers || [])]
    .sort((a, b) => a.min_qty - b.min_qty)
    .forEach((t) => {
      if (qty >= t.min_qty) tier = t;
    });
  return tier;
}
